/* eslint-disable import/prefer-default-export */
const STORAGE_SHOPIFY_SETUP_SHOP_SEEN = '__STORAGE_SHOPIFY_SETUP_SHOP_SEEN__';

const getSeenShopSetupValue = () => {
  const serialized = window.sessionStorage.getItem(
    STORAGE_SHOPIFY_SETUP_SHOP_SEEN,
  );
  return serialized ? JSON.parse(serialized) : {};
};

const hasSeenShopSetupModal = shopIdentifier => {
  const value = getSeenShopSetupValue();
  return value[shopIdentifier] === true;
};

const setSeenShopSetupModal = shopIdentifier => {
  const value = {
    ...getSeenShopSetupValue(),
    [shopIdentifier]: true,
  };
  window.sessionStorage.setItem(
    STORAGE_SHOPIFY_SETUP_SHOP_SEEN,
    JSON.stringify(value),
  );
};

export const SeenShopSetupModalSessionStorage = {
  hasSeenShopSetupModal,
  setSeenShopSetupModal,
};
